<template>
  <div class="filter-container">
    <div class="d-flex justify-space-between">
      <div class="filters-wrapper d-flex">
        <div
          v-for="filter in filters"
          :key="filter.id"
          class="mb-0">
          <qx-input-row
            v-model="innerFilterStates[filter.id]"
            class="block-filter"
            v-bind="getFilterProps(filter)"
            :max-height="300" />
        </div>
      </div>
      <div class="d-flex align-center">
        <qx-button
          v-show="isFilterActive"
          id="clear-filters"
          state="passive"
          :action="clearFilters">
          <template #button-content>
            <div class="d-flex text-nowrap">
              <em class="qx-icon icon-cancel mr-1" />
              <span>
                {{ string.clearFilters }}
              </span>
            </div>
          </template>
        </qx-button>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';

import QxInputRow from '@/elements/QxInputRow';
import QxButton from '@/elements/button.vue';
import { getNonEmptyObjectProps } from '@/elements/utils.js';

export default {
  name: 'QxBlockFilters',
  components: {
    QxInputRow,
    QxButton,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerFilterStates: {},
    };
  },
  computed: {
    string() {
      return {
        defaultPlaceholder: this.$gettext('Filter'),
        clearFilters: this.$gettext('Clear filters'),
      };
    },
    isFilterActive() {
      return getNonEmptyObjectProps(this.innerFilterStates) > 0;
    },
  },
  created() {
    this.innerFilterStates = cloneDeep(this.modelValue);
    this.$watch('innerFilterStates', debounce(this.emitFilters, 200), { deep: true });
  },
  methods: {
    getFilterProps(filter) {
      const options = {
        id: `${filter.id}-new-filter`,
        trim: true,
        placeholder: filter.label || string.defaultPlaceholder,
        enableErrorBlock: false,
        name: filter.id,
      };
      if (filter.type === 'options') {
        options.options = filter.options;
        options.rowType = 'select';
        options.searchable = true;
      } else {
        options.rowType = 'input';
      }
      return options;
    },
    clearFilters() {
      for (const key of Object.keys(this.innerFilterStates)) {
        this.innerFilterStates[key] = '';
      }
      this.emitFilters();
    },
    emitFilters() {
      this.$emit('update:modelValue', cloneDeep(this.innerFilterStates));
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  background: $left-panel-grey;
  margin-bottom: 12px;
  padding: 18px 0px;
  .filters-wrapper {
    gap: 15px;
  }
  .block-filter {
    min-width: 300px;
    margin-bottom: 0px !important;
  }
}
.icon-cancel {
  font-size: 20px;
}
</style>
